<template>
<div class="EditText">
  <span @click="()=>{edit = true}" v-if="!edit">{{value}}</span>
  <v-text-field
    autofocus
    style=""
    type="text"
    required
    label="Название файла"
    v-model="values"
    @change="onChange"
    @focusout="onChange"
    v-else
  />
</div>
</template>
<script>
export default {
  name: 'EditText',
  components:{},
  data:()=>({
    edit: false
  }),
  props:{
    value: {type: String},
    mimetype: {type: String}
  },
  methods:{
    onChange(){
      this.edit = false
      const reg = new RegExp(`${this.mimetype}$`)
      if(!reg.test(this.values)){
        this.values = `${this.values}${this.mimetype}`
        this.$emit('change',`${this.values}${this.mimetype}`)
        return
      }
      this.$emit('change',`${this.values}`)
    }
  },
  computed:{
    values: {
      get(){return this.value},
      set(val){
        const reg = /\/|\\/g
        this.$emit('input',val.replace(reg,''))
      }
    }
  },
  mounted(){},
  watch:{}
}
</script>
<style lang="sass" scoped>

</style>
